export default {"src":"/_next/static/media/CVNA.c5f9ceff.svg","height":18,"width":18};